/**
 * Experience Repository Factory
 *
 * Factory Pattern: Creates configured repository instances
 * Dependency Inversion: Provides abstraction for repository creation
 */

import { IExperienceRepository } from '../interfaces/IExperienceRepository';
import { ExperienceRepository } from '../repositories/ExperienceRepository';
import { AxiosHttpClient } from '../implementations/AxiosHttpClient';

export class ExperienceRepositoryFactory {
  private static instance: IExperienceRepository | null = null;

  /**
   * Get or create a singleton instance of ExperienceRepository
   */
  static getInstance(): IExperienceRepository {
    if (!this.instance) {
      const baseUrl =
        process.env.NEXT_PUBLIC_API_URL ||
        'http://localhost:4000/nexgo-gateway';
      const httpClient = new AxiosHttpClient();
      this.instance = new ExperienceRepository(httpClient, baseUrl);
    }
    return this.instance;
  }

  /**
   * Create a new instance with custom configuration
   */
  static create(
    baseUrl: string,
    httpClient?: AxiosHttpClient
  ): IExperienceRepository {
    const client = httpClient || new AxiosHttpClient();
    return new ExperienceRepository(client, baseUrl);
  }

  /**
   * Reset singleton instance (useful for testing)
   */
  static reset(): void {
    this.instance = null;
  }
}
